module.exports = __webpack_public_path__ + "612e617f5d72975e63e53d793d757785.svg";